module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1: C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVIL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGENDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-1"
    }
  }, [_vm._v("The Amos Deason House’s Bloody Past (Ellisville)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-2"
    }
  }, [_vm._v("The Impregnating Bullet (Raymond)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-3"
    }
  }, [_vm._v("The Ghosts of Beauvoir (Biloxi)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-4"
    }
  }, [_vm._v("McRaven’s Civil War Legacy (Vicksburg)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-5"
    }
  }, [_vm._v("The Lost Victims of the Chunky Creek Train Disaster (Chunky)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 2: M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSTERIOUS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mississippi’s Chupacabra (Mendenhall and Picayune)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mississippi Wild Man (Vicksburg and Lost Gap)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-First-Century Bigfoot Sightings (Tishomingo, Vicksburg and Toomsuba)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three-Legged Lady Road (Columbus)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devil Worshiper Road (Waynesboro)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 3: M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSTERIES")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mississippi’s 1977 UFO Sightings (Flora)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pascagoula Alien Abduction (Pascagoula)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 4: L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGENDARY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bellevue (Pascagoula)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lyric Theatre (Tupelo)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chapel of the Cross (Mannsdale)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mississippi’s Prehistoric “Great Wall” (Claiborne County)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mysteries of Deer Island (Biloxi)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuckey’s Bridge (Chunky)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Causeyville General Store (Causeyville)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rowan Oak (Oxford)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Devil’s Punchbowl (Natchez)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Biloxi Lighthouse (Biloxi)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Witch Dance (Tupelo)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King’s Tavern (Natchez)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary Mahoney’s (Biloxi)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spengler Hotel (Jackson)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Capitol Museum (Jackson)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Merrehope (Meridian)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rosswood Plantation (Lorman)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Windsor Ruins (Port Gibson)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicksburg National Battlefield (Vicksburg)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 5: L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGENDARY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARACTERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phantom Barber of Pascagoula (Pascagoula)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Johnson’s Mysterious Life and Death (Clarksdale)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Boy Prophet of Hazlehurst (Hazlehurst)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Was Jimmie Rodgers Really Born? (Meridian)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 6: N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIVE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICAN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGENDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Singing River (Pascagoula)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Legend of Nanih Waiya Mound (Winston County)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ring in the Oak (Biloxi)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Little People (Mississippi Choctaw Indian Reservation)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 7: L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REASURE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGENDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chief Toby Tubby’s Buried Gold (College Hill)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lost Yankee Payroll (Holly Springs)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Buried Treasure of Patrick Scott, the Irish Pirate (Ocean Springs)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Ben Sherrod")]), _vm._v(" Disaster (Black Hawk Point)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rocky Springs’ Outlaw Treasure (Rocky Springs)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Copeland Gang’s Lost Loot (Catahoula)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 8: L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGENDARY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URDERERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mississippi’s Lizzie Borden (Laurel)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Casanova Killer Comes to Mississippi (Jackson)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Horrible Harpe Brothers (Natchez)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 9: M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSTERIOUS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EATHS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mercritis Epidemic (Mississippi)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Happened to Jacqueline Levitz? (Vicksburg)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Killed Janie Sharp? (Rural Hill)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death in the Woods (Pearl River)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 10: C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMETERY")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGENDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gypsy Queen of Rose Hill Cemetery (Meridian)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lady in Red (Cruger)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Aberdeen Cemetery (Aberdeen)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grave of Elizabeth “Betsy” Bell (Water Valley)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Natchez City Cemetery (Natchez)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Witch’s Grave in Glenwood Cemetery (Yazoo City)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Johnson’s Three Grave Sites (Leflore County)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mass Grave Discovered at the University of Mississippi Medical School (Jackson)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unknown Confederate Cemetery on the Natchez Trace (Tupelo)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friendship Cemetery (Columbus)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Works_Consulted",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSULTED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0